
import { Container } from "@mui/material";
import { requester } from "App";
import P from "components/P";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useContext, useEffect } from "react";

function Error404Page() {
    const { isMobile } = useContext(BrowserDetectContext);
    
    return (
        <Container>
            {
                isMobile
                    ?
                    <Container maxWidth={500}>
                        <P>404</P>
                    </Container>
                    :
                    <Container maxWidth={1200}>
                        <P>404</P>
                    </Container>
            }
        </Container>
    );
}


export default Error404Page;